"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processSingleAnswer = processSingleAnswer;
const boolean_answer_to_number_1 = require("./boolean-answer-to-number");
const calculate_base_score_1 = require("./calculate-base-score");
function processSingleAnswer(userAnswer, candidateAnswer) {
    if (userAnswer.questionId !== candidateAnswer.questionId) {
        throw new Error("Question IDs do not match");
    }
    const questionId = userAnswer.questionId;
    const numericUserAnswer = (0, boolean_answer_to_number_1.booleanAnswerToNumber)(userAnswer.answer);
    const numericCandidateAnswer = (0, boolean_answer_to_number_1.booleanAnswerToNumber)(candidateAnswer.answer);
    // Only process if both answers are defined (not undefined/missing)
    if (numericUserAnswer === undefined || numericCandidateAnswer === undefined) {
        return { questionId, score: 0, weight: 0 };
    }
    const baseScore = (0, calculate_base_score_1.calculateBaseScore)(numericUserAnswer, numericCandidateAnswer);
    // Weight is 1 for all defined answers (including neutral)
    let weight = 1;
    let finalScore = baseScore;
    if (userAnswer.isImportant && weight > 0) {
        finalScore *= 2;
        weight *= 2;
    }
    return { questionId, score: finalScore, weight: weight };
}
